import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expandLess",
  "use": "expandLess-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"expandLess\">\n<path d=\"M5.29461 0.999531L0.704609 5.58953C0.314609 5.97953 0.314609 6.60953 0.704609 6.99953C1.09461 7.38953 1.72461 7.38953 2.11461 6.99953L6.00461 3.11953L9.88461 6.99953C10.2746 7.38953 10.9046 7.38953 11.2946 6.99953C11.6846 6.60953 11.6846 5.97953 11.2946 5.58953L6.70461 0.999531C6.32461 0.609531 5.68461 0.609531 5.29461 0.999531Z\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/expandLess.svg
// module id = HBPd
// module chunks = 13